import {Card} from '@material-ui/core';
import React, {useContext} from 'react';
import Tabs from './SubTabs';
import {ThemeContext} from '../../../themes/ThemeProvider';

const RuleGroup = ({setTabValue, recordFormatId}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  return (
    <>
      <Card className={`${classes.cardBordernoneStyles} mb-0`} elevation={0}>
        <Tabs recordFormatId={recordFormatId} setTabValue={setTabValue} />
      </Card>
    </>
  );
};

export default RuleGroup;
